import axios from 'axios';

// Create axios instance - this is now also exported from AuthContext
// Use the same origin as the page (infrastructure routes /api to backend)
const API_URL = window.location.origin;

console.log('🌐 API Configuration:', {
  origin: window.location.origin,
  baseURL: `${API_URL}/api`
});

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// No authentication needed - simple password access only

export default api;
